import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    staticClass: "page"
  }, [_c("template", {
    slot: "header"
  }, [_vm.isBusiness ? _c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", [_vm.buttonPerms(_vm.$route.path + ":add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1) : _c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "企业名称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "企业名称"
    },
    model: {
      value: _vm.searchForm.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "labName", $$v);
      },
      expression: "searchForm.labName"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")]), _vm.buttonPerms(_vm.$route.path + ":add") ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 添加")]) : _vm._e()], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "current-page": _vm.searchForm.page,
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.buttonPerms(_vm.$route.path + ":edit") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm.buttonPerms(_vm.$route.path + ":del") ? _c("el-button", {
          attrs: {
            size: "mini",
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row.id);
            }
          }
        }, [_vm._v("删除")]) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "labName",
      label: "归属机构",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "specName",
      label: "规格名称",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "price",
      label: "价格",
      "min-width": "100",
      sortable: "custom"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "reportOrigin",
      label: "统计地区",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "placeOrigin",
      label: "产地、厂家",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productionDate",
      label: "生产日期",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.dayjs(scope.row.productionDate).format("YYYY-MM-DD")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "reportDate",
      label: "统计日期",
      width: "200",
      sortable: "custom"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", [_vm._v(_vm._s(_vm.dayjs(scope.row.reportDate).format("YYYY-MM-DD")))])];
      }
    }])
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  }), _c("el-dialog", {
    attrs: {
      visible: _vm.editDialogShow,
      title: _vm.editDialogTitle,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialogShow = $event;
      },
      close: function close($event) {
        return _vm.initFormData(_vm.emptyFormData);
      }
    }
  }, [_c("el-form", {
    ref: "formDataVerify",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [!_vm.isBusiness ? _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "所属企业",
      "label-width": _vm.formLabelWidth,
      prop: "labId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "align-items": "center"
    }
  }, [_c("el-input", {
    attrs: {
      readonly: "",
      autocomplete: "off",
      placeholder: "请选择所属企业"
    },
    model: {
      value: _vm.formData.labName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "labName", $$v);
      },
      expression: "formData.labName"
    }
  }), _c("el-button", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      disabled: _vm.isBusiness,
      size: "mini",
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.lab_show = !_vm.lab_show;
      }
    }
  }, [_vm._v("选择")])], 1)])], 1) : _vm._e(), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "统计日期",
      "label-width": _vm.formLabelWidth,
      prop: "reportDate"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      placeholder: "请选择日期",
      format: "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.formData.reportDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "reportDate", $$v);
      },
      expression: "formData.reportDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "统计地区",
      "label-width": _vm.formLabelWidth,
      prop: "reportOrigin"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入统计地区",
      autocomplete: "off"
    },
    model: {
      value: _vm.formData.reportOrigin,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "reportOrigin", $$v);
      },
      expression: "formData.reportOrigin"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "生产日期",
      "label-width": _vm.formLabelWidth,
      prop: "productionDate"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      placeholder: "请选择日期",
      format: "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.formData.productionDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "productionDate", $$v);
      },
      expression: "formData.productionDate"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 5
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "产地、厂家",
      "label-width": _vm.formLabelWidth,
      prop: "placeOrigin"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入产地|厂家",
      autocomplete: "off"
    },
    model: {
      value: _vm.formData.placeOrigin,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "placeOrigin", $$v);
      },
      expression: "formData.placeOrigin"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "规格名称",
      "label-width": _vm.formLabelWidth,
      prop: "specName"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入规格名称",
      autocomplete: "off"
    },
    model: {
      value: _vm.formData.specName,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "specName", $$v);
      },
      expression: "formData.specName"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "价格",
      "label-width": _vm.formLabelWidth,
      prop: "price"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入价格",
      autocomplete: "off"
    },
    model: {
      value: _vm.formData.price,
      callback: function callback($$v) {
        _vm.$set(_vm.formData, "price", $$v);
      },
      expression: "formData.price"
    }
  })], 1)], 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeEditDialogShow
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.submitFormData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm.lab_show ? _c("labSel", {
    on: {
      "child-lab-sel": _vm.labSel
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };